import Constants from '@/Constants';
import { useHasModules } from '@/hooks/useHasModules';
import { ApplicationState } from '@/store';
import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, Route, Switch, useHistory } from 'react-router-dom';
import BuzzQuiz from './BUZZ/Quiz';
import Courses from './LMS/Courses';
import Programs from './LMS/Programs';
import Items from './Playlist/Items';
import Lists from './Playlist/Lists';
import './style.scss';

interface ContentsRoutes {
    path: string;
    title: string;
    moduleId: number;
    component: ReactElement;
}

const Contents: React.FC = () => {
    const history = useHistory();
    const { hasLms, hasPlaylist, hasBuzz } = useHasModules();

    const [routes, setRoutes] = useState<ContentsRoutes[]>([]);
    const [selectedModuleId, setSelectedModuleId] = useState<number>();

    const modulesWithSubMenu: number[] = [Constants.LMS_MODULE_ID, Constants.PLAYLIST_MODULE_ID];

    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const handleSelectModule = (moduleId: number): void => {
        setSelectedModuleId(moduleId);
    };

    const currentModuleHasSubMenu = (): boolean => {
        return modulesWithSubMenu.indexOf(selectedModuleId || 0) > -1;
    };

    useEffect(() => {
        const tmpRoutes: ContentsRoutes[] = [...routes];

        if (hasBuzz) {
            tmpRoutes.push({
                path: '/contents/buzz/tests',
                title: '',
                moduleId: Constants.BUZZ_MODULE_ID,
                component: <BuzzQuiz />,
            });
        }

        if (hasLms) {
            tmpRoutes.push({
                path: '/contents/lms/courses',
                title: 'COURSES',
                moduleId: Constants.LMS_MODULE_ID,
                component: <Courses />,
            });
            tmpRoutes.push({
                path: '/contents/lms/programs',
                title: 'PROGRAMS',
                moduleId: Constants.LMS_MODULE_ID,
                component: <Programs />,
            });
        }

        if (hasPlaylist) {
            tmpRoutes.push({
                path: '/contents/playlist/items',
                title: 'ITEMS',
                moduleId: Constants.PLAYLIST_MODULE_ID,
                component: <Items />,
            });
            tmpRoutes.push({
                path: '/contents/playlist/lists',
                title: 'LISTS',
                moduleId: Constants.PLAYLIST_MODULE_ID,
                component: <Lists />,
            });
        }

        setRoutes(tmpRoutes);
    }, [hasBuzz, hasLms, hasPlaylist]);

    useEffect(() => {
        if (routes.length > 0) {
            const currentRoute: ContentsRoutes | undefined = routes.find((route: ContentsRoutes) => route.path === history.location.pathname);

            if (currentRoute) {
                setSelectedModuleId(currentRoute.moduleId);
            } else {
                setSelectedModuleId(routes[0].moduleId);
            }
        }
    }, [routes]);

    useEffect(() => {
        if (selectedModuleId) {
            const currentRoute: ContentsRoutes | undefined = routes.find((route: ContentsRoutes) => route.path === history.location.pathname);
            if (!currentRoute || currentRoute.moduleId !== selectedModuleId) {
                history.push(routes.filter((route: ContentsRoutes) => route.moduleId === selectedModuleId)[0].path);
            }
        }
    }, [selectedModuleId, history.location]);

    const handleTitleTranslation = (route: string) => {
        for (const [key, value] of Object.entries(strings)) {
            if (key === route) {
                return value;
            }
        }
    };

    return (
        <div className="contents">
            <div className="container">
                <header>
                    <ul className="nav modules">
                        {/* {hasBuzz && (
                            <li className="nav-item">
                                <a
                                    className={`nav-link ${selectedModuleId === Constants.BUZZ_MODULE_ID ? 'active' : ''}`}
                                    onClick={() => handleSelectModule(Constants.BUZZ_MODULE_ID)}
                                >
                                    {strings.BUZZ}
                                </a>
                            </li>
                        )} */}

                        {hasLms && (
                            <li className="nav-item">
                                <a
                                    className={`nav-link ${selectedModuleId === Constants.LMS_MODULE_ID ? 'active' : ''}`}
                                    onClick={() => handleSelectModule(Constants.LMS_MODULE_ID)}
                                >
                                    {strings.LMS}
                                </a>
                            </li>
                        )}

                        {hasPlaylist && (
                            <li className="nav-item">
                                <a
                                    className={`nav-link ${selectedModuleId === Constants.PLAYLIST_MODULE_ID ? 'active' : ''}`}
                                    onClick={() => handleSelectModule(Constants.PLAYLIST_MODULE_ID)}
                                >
                                    {strings.PLAYLIST}
                                </a>
                            </li>
                        )}
                    </ul>
                    {currentModuleHasSubMenu() && (
                        <ul className="nav modules__sections">
                            {routes.map((route: ContentsRoutes) => {
                                if (route.moduleId === selectedModuleId) {
                                    return (
                                        <li className="nav-item" key={route.path}>
                                            <NavLink activeClassName="active" className="nav-link" exact to={route.path}>
                                                {handleTitleTranslation(route.title)}
                                            </NavLink>
                                        </li>
                                    );
                                }
                            })}
                        </ul>
                    )}
                </header>
                <Switch>
                    {routes.map((route: ContentsRoutes) => {
                        if (route.moduleId === selectedModuleId) {
                            return (
                                <Route exact key={route.path} path={route.path}>
                                    {route.component}
                                </Route>
                            );
                        }
                    })}
                </Switch>
            </div>
        </div>
    );
};

export default Contents;
